import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideRouter, RouterModule, withHashLocation } from '@angular/router';

import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { authInterceptorFn } from './interceptors/auth.interceptor';

import { AngularFirestoreModule } from '@angular/fire/compat/firestore';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { initializeApp as firebaseInitializeApp } from 'firebase/app';
import { provideFirebaseApp, initializeApp } from '@angular/fire/app';
import { getAuth, provideAuth } from '@angular/fire/auth';
import { getFirestore, provideFirestore } from '@angular/fire/firestore'
import { provideAnimations } from '@angular/platform-browser/animations';
import { getStorage, provideStorage } from '@angular/fire/storage';
import { routes } from './app.routes';
import { environment } from '../environments/environment';
import { GoogleMapsModule } from '@angular/google-maps';
const firebaseConfig = environment.config_firebase;

// Inicialización sincrónica necesaria para que getAuth() funcione en constructores
// de servicios antes de que el DI de Angular haya ejecutado provideFirebaseApp.
// Firebase SDK v9+ retorna el app existente si ya fue creado con la misma config.
firebaseInitializeApp(firebaseConfig);

export const appConfig: ApplicationConfig = {
        providers: [
        //  AppRoutingModule,{ path: '',component:InicioComponent}
        //provideRouter([{ path: 'test',component:InicioComponent}], withHashLocation()),
          provideRouter(routes, withHashLocation()),

          provideAnimations(),//esto es para arreglar browseranimation module
          
          // ✅ HttpClient moderno con interceptor de autenticación
          provideHttpClient(
            withInterceptors([authInterceptorFn])
          ),
          
        importProvidersFrom(
          BrowserAnimationsModule,
          AngularFirestoreModule,GoogleMapsModule
        ),
        provideFirebaseApp(() => initializeApp(firebaseConfig)),
        provideAuth(() => getAuth()),
        provideFirestore(() => getFirestore()),
        provideStorage(() => getStorage())

        ]
      };
